export { DetailInfo } from './DetailInfo';
